import { GET_SUPER_ADMIN_LOCATION_BY_PRM_ERROR, GET_SUPER_ADMIN_LOCATION_BY_PRM_LOADING, GET_SUPER_ADMIN_LOCATION_BY_PRM_SUCCESS } from "../type/Constant";

let initialState = {
  getLocationByPRM: {
    loading: false,
    data: null,
    error: false,
    errors: null,
    success: false,
    pagination:{}
  },
};

export default function getLocationByPRM(state = initialState, action) {
  switch (action.type) {
    
    case GET_SUPER_ADMIN_LOCATION_BY_PRM_LOADING:
      return { ...state, getLocationByPRM: { ...state.getLocationByPRM, loading: true, error: false, errors: [], success: false } };

    case GET_SUPER_ADMIN_LOCATION_BY_PRM_SUCCESS:
      return { ...state, getLocationByPRM: { ...state.getLocationByPRM, loading: false, error: false, errors: [], success: true, data: action.response.data, pagination: action.pagination } };

    case GET_SUPER_ADMIN_LOCATION_BY_PRM_ERROR:
      return { ...state, getLocationByPRM: { ...state.getLocationByPRM, loading: false, error: true, errors: action.errors, success: false, data: null } };

    default:
      return state;
  }
}
